// extracted by mini-css-extract-plugin
export var note = "program-module--note--b1113";
export var program = "program-module--program--e8fc2";
export var program__block = "program-module--program__block--75dc0";
export var program__block_body = "program-module--program__block_body--cbb56";
export var program__img = "program-module--program__img--4554e";
export var program__title = "program-module--program__title--2109a";
export var program__wrapper = "program-module--program__wrapper--903ac";
export var program__wrapper_main = "program-module--program__wrapper_main--c7042";